import React, { Component } from "react";
import { PageHeader, Form, Container, Row, Col, Button, ButtonToolbar } from "react-bootstrap";
import HeadOfficeList from "containers/headoffice/HeadOfficeList";


import { API } from "aws-amplify";
import ReactTable from "react-table";
import 'react-table/react-table.css';


export default class HeadOfficeSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            
            name: '',
            
            isLoading: true,
            HeadOffices: [],
            filter: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        
        document.title = "Cityscope Head Office Search";
        this.setState({ isLoading: false });      
    }


    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

   

    handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        console.log(this.state.filter);
 

        this.setState(state => ({
                        filter : {
                            
                            name: this.state.name
                        }
        }));

        console.log(this.state.filter);
        

     }

    renderHeadOffices() {
        return (
            
                <Container fluid >
                   <Row >
                        <Col sm={12} md={12} lg={12}>
                            <h6>
                                Cityscope Head Office Search
                                </h6>
                    
                        </Col>
                    </Row>
                    
                        

                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >

                        
                        <Col lg={2}>
                            
                            </Col>
                        
                        <Col lg={2}>
                        <Form.Group controlId="name">
                                <Form.Control
                                    type="input"
                                    value={this.state.name}
                                    onChange={this.handleChange}
                                    placeholder="Head Office Name containing" />
                            
                            </Form.Group>
                        </Col>
                        <Col lg={2}>
                       
                        </Col>
                        <Col>
                            <Button type="submit">Search</Button>
                        </Col>

                    </Form.Row>
                </Form>
                        

                    <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>

                            <HeadOfficeList
                            filter={this.state.filter}
                            isAuthenticated={this.props.isAuthenticated}
                            isLoading={this.state.isLoading}
                            
                            controlType="table"
                        />

                        </Col>
                    </Row>
                </Container>

        );
    }
  render() {
    return (

        <div className="HeadOfficeSearch">
            {this.props.isAuthenticated ? this.renderHeadOffices() : console.log("error)")}
        </div>
    );
  }
}
